import { conditionalString } from '@silverhand/essentials';
import classNames from 'classnames';
import i18next from 'i18next';
import { useContext } from 'react';
import { Helmet } from 'react-helmet';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import cowcamoAppleTouchIcon from '@/shared/assets/cowcamo-apple-touch-icon.png';
import cowcamoFaviconIco from '@/shared/assets/cowcamo-favicon.ico';
import cowcamoFaviconSvg from '@/shared/assets/cowcamo-favicon.svg';

import styles from './index.module.scss';

/**
 * User React Helmet to manage html and body attributes
 * @see https://github.com/nfl/react-helmet
 *
 * - lang: set html lang attribute
 * - data-theme: set html data-theme attribute
 * - favicon: set favicon
 * - apple-touch-icon: set apple touch icon
 * - body class: set preview body class
 * - body class: set platform body class
 * - body class: set theme body class
 * - custom css: set custom css style tag
 */

const AppMeta = () => {
  const { experienceSettings, theme, platform, isPreview } = useContext(PageContext);

  return (
    <Helmet>
      <html lang={i18next.language} dir={i18next.dir()} data-theme={theme} />
      {/*
        Favicon is pinned to the cowcamo brand assets. The upstream SIE `branding.favicon`
        / `darkFavicon` override was intentionally dropped: cowcamo does not use SIE branding
        (never configured), so the override path was removed to keep this simple.
      */}
      <link rel="icon" type="image/svg+xml" href={cowcamoFaviconSvg} />
      <link rel="alternate icon" type="image/x-icon" href={cowcamoFaviconIco} />
      <link rel="apple-touch-icon" sizes="180x180" href={cowcamoAppleTouchIcon} />
      {experienceSettings?.customCss && <style>{experienceSettings.customCss}</style>}
      <body
        className={classNames(
          conditionalString(isPreview && styles.preview),
          platform === 'mobile' ? 'mobile' : 'desktop',
          conditionalString(styles[theme])
        )}
      />
    </Helmet>
  );
};

export default AppMeta;
